import { camposVisibles, compilarSistemaDetalle } from './escalasEvolucion';

// Solo estados: un select también puede describir una curación o un retiro.
// Los textos y dependencias siguen saliendo del catálogo existente.
const CAMPOS_ESTADO = {
  neuro: ['sedacion', 'conciencia', 'orientacion', 'delirium', 'dolor', 'contencion'],
  hemodinamia: ['presion', 'fc', 'ritmo', 'temp'],
};
const HALLAZGOS_ESTADO = {
  neuro: ['Agitación psicomotora', 'Déficit motor'],
  hemodinamia: ['Arritmia'],
  gastro: ['Náuseas o vómitos', 'Distensión abdominal', 'Ictericia'],
  renal: ['Globo vesical', 'Retención urinaria'],
};

const normalizar = texto => String(texto || '').trim().replace(/\.$/, '').replace(/\s+/g, ' ').toLocaleLowerCase();
const conservar = () => false;

// La coincidencia textual no acredita el mismo momento. Los datos de puentes,
// controles y notas atribuidas conservan su narración, aunque no impriman hora.
function tieneProcedencia(state, sistemaId, trayectoria, superados) {
  if (trayectoria != null || superados != null) return true;
  if (Array.isArray(state._prosa) && state._prosa.some(p => p?.sistema === sistemaId)) return true;
  const st = state.sistemas?.[sistemaId] || {};
  if (['_examenCampos', '_examenLineasProyectadas', '_concienciaExamen', '_contextosEscalas']
    .some(k => st[k] != null)) return true;
  if (sistemaId === 'ventilacion' && state._viaAereaReplay) return true;
  if (['_accionesEnrutadas', '_examenEnrutado', '_controlEnrutado', '_escalasEnrutadas']
    .some(k => state[k] && Object.keys(state[k]).length)) return true;
  if (Array.isArray(state._sembradoNormal) && state._sembradoNormal.some(clave =>
    typeof clave === 'string' && clave.startsWith(`${sistemaId}:`))) return true;
  return ['_puenteCampos', '_puenteEscalas', '_puenteSoportes', '_camposSinEco', '_escalasSinEco']
    .some(k => Object.keys(state[k] || {}).some(clave => clave.startsWith(`${sistemaId}:`)));
}

// Devuelve un predicado para omitir SOLO la copia automática de una frase que
// la nota ya conserva. No modifica notas, valores, escalas ni actos. La nota
// completa debe consistir en estados del catálogo actualmente seleccionados;
// cualquier otra prosa, cifra, pregunta o contexto deja el texto intacto.
export function catalogoYaNarradoEnNota(state, sistemaId, {
  nota, campos, hallazgos, generiza = t => t, trayectoria, superados,
} = {}) {
  if (!nota?.trim() || tieneProcedencia(state, sistemaId, trayectoria, superados)) return conservar;
  const permitidos = new Set(CAMPOS_ESTADO[sistemaId] || []);
  const estaticos = Object.fromEntries(camposVisibles(sistemaId, campos || {})
    .filter(c => permitidos.has(c.k) && c.tipo === 'select' && c.opciones.includes(campos[c.k]))
    .map(c => [c.k, campos[c.k]]));
  // Generar la frase con el compilador conserva sustantivos, agrupación y
  // concordancia. Nunca comparar valores aislados como "No" o "Presentes".
  const frases = compilarSistemaDetalle(sistemaId, estaticos, {}).lineas.map(generiza);
  for (const h of hallazgos || []) {
    if ((HALLAZGOS_ESTADO[sistemaId] || []).includes(h)) frases.push(generiza(`${h}.`));
  }
  const vocabulario = new Set(frases.map(normalizar).filter(t => t && !/[\d?!:;\n]/.test(t)));
  const afirmaciones = nota.trim().split(/\.\s+|\n+/).map(normalizar);
  if (!afirmaciones.length || afirmaciones.some(t => !vocabulario.has(t))) return conservar;
  const dichas = new Set(afirmaciones);
  return texto => dichas.has(normalizar(texto));
}
